var _module_exports = "<div>\r\n    These yards have not yet listed their inventory on Row52. Let them know you want to see what vehicles are in their yard!\r\n</div>";;
var path = 'yards/NonParticipantYard.html';
window.angular.module('row52-templates').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;